<template>
  <v-dialog
    v-model="getEditUser"
    @click:outside="_setActive(false)"
    :width="dialogStyle"
    id="edit-user-dialog"
  >
    <v-card
      style="overflow-x: hidden; color:white;"
      color="primary"
      v-if="userData"
    >
      <v-card-title background-color="primary" style="height:150px;">
        <v-container>
          <v-row class="d-flex flex-row justify-center">
            <h2 color="primary">Edit User</h2>
          </v-row>
        </v-container>
      </v-card-title>
      <div style="background-color:white;" class="pt-8">
        <v-form class="pa-3" v-model="isFormValid">
          <v-text-field
            v-model="userData.user_name"
            label="User Name"
            id="edit-user-name"
            filled
            required
          ></v-text-field>
          <v-text-field
            v-model="userData.email"
            label="Email"
            id="edit-email"
            filled
            :rules="emailRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="userData.contact.phone"
            label="Phone"
            id="edit-phone"
            :rules="phoneRules"
            filled
            required
          ></v-text-field>
          <v-text-field
            v-model="userData.address.address_1"
            label="Address 1"
            id="edit-address-1"
            filled
            required
          ></v-text-field>
          <v-text-field
            v-model="userData.address.address_2"
            label="Address 2"
            id="edit-address-2"
            filled
            required
          ></v-text-field>
          <v-text-field
            v-model="userData.address.city"
            label="City"
            id="edit-city"
            filled
            required
          ></v-text-field>
          <v-select
            v-model="userData.address.state"
            label="State"
            id="edit-state"
            filled
            :items="getStates"
          ></v-select>
          <v-text-field
            v-model="userData.address.country"
            label="Country"
            id="edit-country"
            filled
            required
          ></v-text-field>
          <v-text-field
            v-model="userData.address.zip"
            label="Zip Code"
            id="edit-zip"
            filled
            required
          ></v-text-field>
          <v-select
            v-if="_getClientGroupsAreSet"
            v-model="userData.group_id[0]"
            label="Groups Viewing"
            filled
            item-value="uuid"
            item-text="group_name"
            @input="changed = true"
            id="profile-user-state"
            :items="all_groups"
          ></v-select>
          <v-text-field
            v-if="!data"
            v-model="password"
            label="New Password"
            id="edit-password"
            filled
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            required
          ></v-text-field>
          <v-select
            v-if="client.client_name === 'avis'"
            v-model="userData.location"
            label="Location"
            filled
            item-text="group_name"
            @input="changed = true"
            id="profile-user-state"
            :items="client.groups"
          ></v-select>
        </v-form>
        <div class="d-flex justify-center pb-5">
          <v-btn
            large
            color="primary"
            style="width: 50%;"
            :disabled="!isFormValid"
            @click="clickHandler"
            id="edit-update-button"
            >Update</v-btn
          >
        </div>
        <div class="d-flex justify-center pb-5">
          <v-btn
            large
            text
            style="width: 50%;"
            @click="close()"
            id="edit-cancel-button"
            >Cancel</v-btn
          >
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { MobileView } from '@/mixins';

export default {
  data: () => ({
    inviteEmails: [],
    all_groups: [],
    roles: ['admin', 'user'],
    selectedRole: '',
    emailRules: [v => /.+@.+/.test(v) || 'Invalid Email address'],
    isFormValid: false,
    nameRules: [
      v => !!v || 'A value must be entered.',
      v => v.length >= 1 || 'A value must be entered.',
    ],
    phoneRules: [
      v => v.toString().length <= 10 || 'Phone number may not exceed 10 digits',
      v => v.toString().length > 9 || 'Phone number is not long enough.',
    ],
    userData: null,
  }),
  mixins: [MobileView],
  props: ['data'],
  methods: {
    ...mapMutations({
      _setActive: 'account/setEditUser',
    }),
    ...mapActions({
      _updateUser: 'account/updateUser',
    }),
    clickHandler() {
      this.data.type_name = this.selectedRole;
      this.userData.contact.email = this.userData.email;
      this.userData.contact.contact_name = this.userData.user_name;
      delete this.userData.hidden_cards;
      delete this.userData.groups;
      delete this.userData.client_id;
      delete this.userData.password;
      delete this.userData.error;
      delete this.userData.success;
      delete this.userData.type_name;
      this._updateUser({
        data: this.userData,
        typeName: this.data.type_name,
        setCurrentuser: false,
      });
      this._setActive(false);
    },
    close() {
      this.setUserData();
      this._setActive(false);
    },
    setUserData() {
      this.userData = JSON.parse(JSON.stringify(this.data));
      this.selectedRole = this.userData.type_name;
      if (this._getClientGroupsAreSet) {
        this.all_groups = JSON.parse(JSON.stringify(this.client.groups));
        this.all_groups.unshift({ group_name: 'all', uuid: 'all' });
      }
      if (!this.userData.group_id) {
        this.userData.group_id = [];
      }
      if (!this.data.contact) {
        this.userData.contact = {
          contact_name: '',
          phone: '',
          email: '',
        };
      }
      if (!this.data.address) {
        this.userData.address = {
          address_1: '',
          address_2: '',
          city: '',
          country: '',
          state: '',
          zip: '',
        };
      }
    },
  },
  computed: {
    ...mapGetters({
      getEditUser: 'account/getEditUser',
      getStates: 'account/getStates',
      client: 'account/getCurrentClient',
      _getClientGroupsAreSet: 'account/getClientGroupsAreSet',
    }),
    dialogStyle() {
      if (this.showMobileView) {
        return '';
      }
      return '50%';
    },
  },
  mounted() {
    if (this.data) {
      this.setUserData();
    }
  },
  watch: {
    data: {
      handler() {
        this.setUserData();
      },
      deep: true,
    },
  },
};
</script>

<style></style>
